import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const VideoEditingDetailManager = () => {
  const [videoEditing, setVideoEditing] = useState({});
  const [status, setStatus] = useState(1);
  const [editors, setEditors] = useState([]); // List of editors
  const [selectedEditor, setSelectedEditor] = useState(""); // Selected editor
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const getVideoEditingById = async () => {
    try {
      const response = await axios.get(`/video-editing/${id}`);
      setVideoEditing(response.data);
      setStatus(response.data.status || 1);
      setSelectedEditor(response.data.editor || ""); // Only set selectedEditor here
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1); // Set status from fetched data
    } catch (error) {
      console.log(error);
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  const getEditors = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      const editorUsers = response.data.filter(
        (user) => user.role === "editor"
      );
      setEditors(editorUsers);
    } catch (error) {
      console.error("Error fetching editors:", error);
    }
  };

  useEffect(() => {
    getVideoEditingById();
    getEditors();
  }, []);

  const updateVideoEditing = async () => {
    try {
      await axios.put(`/video-editing/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/videoediting-manager");
    } catch (error) {
      console.log(error);
    }
  };
  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  return (
    <Layout>
      <div className="container mt-4">
        {errorMessage && (
          <div
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              class="btn-close shadow-none"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        )}
        <div className="row">
          {/* Left Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Job Details</div>
              <div className="card-body">
                <p>
                  <strong>Event Name:</strong> {videoEditing?.order_name}
                </p>
                <p>
                  <strong>Service Type:</strong>{" "}
                  {videoEditing?.serviceId?.service}
                </p>
                <p>
                  <strong>Album Type:</strong> {videoEditing?.order_name}
                </p>
              </div>
            </div>{" "}
            <div className="card mb-3">
              <div className="card-header fw-600">Order Details</div>
              <div className="card-body">
                <p>
                  <strong>Video Package :</strong> {videoEditing?.video_package}
                </p>
                <p>
                  <strong>Raw Footage :</strong> {videoEditing?.raw_footage}
                </p>{" "}
                <p>
                  <strong>Output Video :</strong> {videoEditing?.output_video}
                </p>{" "}
                <p>
                  <strong>Color Correction :</strong>{" "}
                  {videoEditing?.color_correction}
                </p>{" "}
                <p>
                  <strong>Music :</strong> {videoEditing?.music}
                </p>{" "}
                <p>
                  <strong>Quantity :</strong> {videoEditing?.quantity}
                </p>{" "}
                <p>
                  <strong>Social media :</strong> {videoEditing.social_media}
                </p>{" "}
                <p>
                  <strong>Link :</strong> {videoEditing.drive_link}
                </p>{" "}
                <p>
                  <strong> Upload:</strong> {videoEditing?.images}
                </p>{" "}
                <p>
                  <strong>Aditional notes :</strong>{" "}
                  {videoEditing?.additional_notes}
                </p>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-header fw-600">Order Operations</div>
              <div className="card-body">
                <p>
                  <strong>Client ID:</strong> {videoEditing.userId?.id}
                </p>
                <p>
                  <strong>Order ID:</strong> {videoEditing.id}
                </p>
                <p>
                  <strong>User Feedback:</strong> {videoEditing.sampleFeedback}
                </p>
                <p>
                  <strong>Order Place Date:</strong>{" "}
                  {new Date(videoEditing.createdAt).toLocaleDateString()}
                </p>

                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>
                <div className="mt-3">
                  <label className="form-label">Select Editor</label>
                  <select
                    className="form-select"
                    value={selectedEditor}
                    onChange={(e) => setSelectedEditor(e.target.value)}
                  >
                    <option value="">Select an editor</option>
                    {editors.map((ed) => (
                      <option key={ed._id} value={ed.fname}>
                        {ed.fname}
                      </option>
                    ))}
                  </select>
                </div>

                <label className="form-label mt-3">File Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={fileLocation}
                  onChange={(e) => setFileLocation(e.target.value)}
                />

                <label className="form-label mt-3">Message</label>
                <input
                  type="text"
                  className="form-control"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />

                <button
                  onClick={updateVideoEditing}
                  className="btn text-light bg_maincolor mt-3"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default VideoEditingDetailManager;
